import { dark_theme_colors } from './shared';
import { ZdsTheme } from './types';

export const darkTheme: ZdsTheme = {
  name: 'dark',
  colors: dark_theme_colors,
};
